/**
 * Plan's sections (#1164, D219/D233.5/D254): Coming up, Goals, More, with
 * Reflections, Coach feedback and Identity & vision as folds in More. The URL
 * keeps its one `?tab=` parameter, so every old link still lands.
 *
 * `resolvePlanSection(tab, { aiEnabled }) -> { section, fold, group }`
 *   - `coming-up` (the default, and what an absent or unknown value means);
 *   - `goals`; `short` and `long` are Goals with that group scrolled to;
 *   - `more`; `identity`, `reflections`, `feedback` are More with that fold open;
 *   - `ai` is More with the AI fold open when AI is enabled, else Coming up.
 *
 * Pure, so the page and its tests read the same table.
 */
export const PLAN_SECTIONS = ["coming-up", "goals", "more"];
export const PLAN_FOLDS = ["reflections", "feedback", "identity"];

const HOME = Object.freeze({ section: "coming-up", fold: null, group: null });

export function resolvePlanSection(tab, { aiEnabled = false } = {}) {
  switch (tab) {
    case "goals":
      return { section: "goals", fold: null, group: null };
    case "more":
      return { section: "more", fold: null, group: null };
    case "short":
    case "long":
      return { section: "goals", fold: null, group: tab };
    case "identity":
    case "reflections":
    case "feedback":
      return { section: "more", fold: tab, group: null };
    case "ai":
      return aiEnabled ? { section: "more", fold: "ai", group: null } : { ...HOME };
    default:
      return { ...HOME };
  }
}
